import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { Field, TextField, Btn, FormButtonDisabler } from '@samc/centricity-core';

export interface IPriceModelFormResult {
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceModelFormModal',
  props: {
    addCloseProp: { type: Function, required: true },
    closeProp: { type: Function, required: true }
  },
  setup(__props: any) {

const props = __props as {
  addCloseProp: (callback: () => Promise<IPriceModelFormResult | undefined>) => void;
  closeProp: () => void;
};



const name = ref('');
const showValidations = ref(false);

const validations = computed((): Record<string, string> => {
  const result: Record<string, string> = {};
  if (name.value.trim().length === 0) {
    result.name = 'Price Model name is required.';
  }
  return result;
});

onMounted(() => {
  props.addCloseProp(async () => {
    showValidations.value = true;
    if (Object.keys(validations.value).length === 0) {
      return { name: name.value.trim() };
    }
    return undefined;
  });
});

return { __sfc: true,props, name, showValidations, validations, Field, TextField, Btn, FormButtonDisabler }
}

})